import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import brower from 'src/helper/brower'
import lang from './lang'
import { getlangV2 } from 'src/helper/getlang'
import { history } from 'src/core/router'
import Toast from 'src/component/Toast'
import Loading from 'src/component/Loading'
import Modal from './Modal'
import Nav from './Nav'
import scroll from 'src/helper/scroll'
import Snap from './Snap'
import Video from './Video'
import {
  chooseImage as handleChooseImage,
  uploadFile as uploadFileImg,
  jumpToUser,
} from '../../../helper/webviewFun'
@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.serviceStore = this.props.store.register('app/service')
  }

  state = {
    lang: lang.ar,
    chooseImage: [],
    uploadFile: [],
    selecttype: 1,
    content: '',
    maxContentL: 300,
    maxChooseL: 4,
    canSubmit: true,
    transactionId: '',
    submitPre: {},
    submitRes: {},
    userInfo: {},
    showVideo: true,
    // by Tang
    selectReportType: 5,
    uploadImgList: '',
    inpVal: '',
    language: 'en',
    // by Tang end
  }

  // componentWillReceiveProps(e) {
  //   console.log(e)
  // }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlangV2(language, lang)
    this.setState({
      lang: lang[language] || lang.en,
    })

    setDocumentTitle(this.state.lang.fr || '')
    let uid = await setUidToken(this.props.location.query)
    this.setState({ language })
    await this.serviceStore.feedbackList(true)
    this.serviceStore.setFeedbackContent({
      id: 0,
      content: '',
      reply: '',
      isReplied: 2,
      score: 0,
      isRead: 2,
    })
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    console.log('hi')
    this.setState({ uid: uid })
    await this.serviceStore.getFeedbackReportList()
    this.serviceStore.setLoading(false)
  }

  async androidUpload() {
    let { maxChooseL, chooseImage } = this.state
    let maxAdd = maxChooseL - chooseImage.length // 限定最大图片
    let params = {
      count: maxAdd > 0 ? maxAdd : 0,
      sizeType: 'compressed',
      mp4Enabled: false,
      os: brower.isAndroid() ? 2 : 1,
    }
    try {
      // 推入图片功能
      await handleChooseImage(params, async (pic) => {
        console.log('pic', '完成了选择图片 现在是上传', pic)
        // 1. 如果没有选择图片，跳出
        if (pic.length <= 0) {
          return
        }
        console.log(this.state.picList)
        // 2. 保存数据，并且展示图片
        let list = this.state.chooseImage
        for (let i = 0; i < pic.length; i++) {
          list.push(pic[i])
        }
        this.setState({
          chooseImage: list,
        })
        let map2 = []
        list.length > 0 &&
          list.map((item, index) => {
            map2.push({
              filePath: item.path,
              fileType: item.image,
            })
          })
        console.log('我是map2哈哈哈哈哈', map2)
        if (map2.length > 0) {
          console.log('进入map2')
          await uploadFileImg(map2, async (d) => {
            let list = d
            this.setState({
              chooseImage: list && list,
            })
            console.log('我是imgUrl阿啊啊', list, this.state.chooseImage)
          })
        }
      })
    } catch (error) {
      this.setState({
        showLoding: false,
      })
      console.error(error)
      this.refs.msg.show(error)
    }
  }
  loadMore = () => {
    let bottom = scroll.checkButtom()
    // console.log(`loadMore`)
    if (bottom) {
      // 如果拉到底部
      console.log('拉到底部')
      this.serviceStore.feedbackList(false)
    }
  }

  async componentDidMount() {
    console.log('componentDidMount')
    // setDocumentTitle(this.state.lang.title)

    window.scroll(0, 0)
    window.addEventListener('scroll', this.loadMore, false)

    if (brower.isIphone()) {
      this.setState({
        showVideo: false,
      })
    }
  }
  getAreaVal = async (e) => {
    console.log('输入id', e.target.value)
    this.setState({
      content: e.target.value || '',
    })
    if (e.target.value && e.target.value.length >= this.state.maxContentL) {
      this.wordTooLong()
    }
  }

  getOrderVal = async (e) => {
    console.log('输入id', e.target.value)
    this.setState({
      transactionId: e.target.value || '',
    })
    console.log('order transactionId', this.state.transactionId)
    console.log('order transactionId', this.state.transactionId)
    console.log('order transactionId', this.state.transactionId)
    console.log('order transactionId', this.state.transactionId)
    if (e.target.value && e.target.value.length >= 255) {
      this.wordTooLong()
    }
  }

  wordTooLong = async () => {
    this.serviceStore.setToastContent(this.state.lang.exceeds)
    this.refs.toast.hideRule(true)
  }

  // 检测图片最大限制
  checkPicL() {
    if (this.state.chooseImage.length > this.state.maxChooseL) {
      this.serviceStore.setToastContent(this.state.lang.maxPic)
      this.refs.toast.hideRule(true)
      return true
    }
    return false
  }

  // 上传图片 + 发布
  async uploadFile(nav) {
    if (nav == 1) {
      this.$logEvent('feeback_success')
    } else {
      this.$logEvent('report_success')
    }
    if (this.state.selecttype == 0) {
      this.serviceStore.setToastContent(this.state.lang.plsSelectType)
      this.refs.toast.hideRule(true)
      return
    }
    if (this.state.content.trim().length < 1) {
      this.serviceStore.setToastContent(this.state.lang.placeholder)
      this.refs.toast.hideRule(true)
      return
    }
    if (this.state.content.trim().length > this.state.maxContentL) {
      this.serviceStore.setToastContent(this.state.lang.exceeds)
      this.refs.toast.hideRule(true)
      return
    }
    // console.log('ftype', this.state.selecttype, brower.isAndroid(), this.state.transactionId)
    if (this.state.selecttype == 3 && true && this.state.transactionId == '') {
      this.serviceStore.setToastContent(this.state.lang.noTransactionId)
      this.refs.toast.hideRule(true)
      return
    }
    // 【2 选择反馈类型3的时候是否需要上传图片】
    // if (this.serviceStore.data.nav == 1 && this.state.chooseImage.length < 1 && this.state.selecttype == 3) {
    //   this.serviceStore.setToastContent(this.state.lang.plsSelectPic)
    //   this.refs.toast.hideRule(true)
    //   return
    // }
    if (this.checkPicL()) {
      return
    }
    this.serviceStore.setLoading(true)

    // 【1 正常测试】
    // await this.isUploadImg()

    // 【2 图片视频上传功能测试】
    // 上传图片功能（开启）
    this.isUploadImg()
    // this.serviceStore.setToastContent(this.state.lang.uploadPicFail)
    // this.refs.toast.hideRule(true)
    /* if (!(brower.isIphone())) {

      let map = this.state.chooseImage
      let map2 = []
      for (let i = 0; i < map.length; i++) {
        map2.push({
          filePath: map[i].path,
          fileType: map[i].image
        })
      }
      if (map2.length > 0) {
        try {
          await uploadFileImg(map2, (d) => {
            let list = d
            let arr = []
            list.map((item, index) => {
              arr.push(item.url)
            })
            let arrString = arr.join(',')
            this.setState({
              uploadImgList: arrString
            })
            this.isUploadImg()
            return
          })
        } catch (error) {

        }
      } else {

      }

    } else {
      await this.isUploadImg()
    } */
  }

  // 上传图片添加操作
  // async feedbackAdd() {
  //   let map = {
  //     content: this.state.content.trim(),
  //     ftype: this.state.selecttype,
  //     file: '',
  //     transactionId: brower.isAndroid() ? this.state.transactionId : '',
  //     os: brower.isAndroid() ? 2 : 1
  //   }

  //   let list = this.state.uploadFile
  //   for (let i = 0; i < list.length; i++) {
  //     if (map.file == '') {
  //       map.file = list[i].url
  //     } else {
  //       map.file = map.file + ',' + list[i].url
  //     }
  //   }

  //   if (this.state.canSubmit) {
  //     await this.setState({
  //       canSubmit: false
  //     })
  //     await this.setState({
  //       submitPre: map
  //     })
  //     let d = await this.serviceStore.feedbackAdd(map)
  //     this.serviceStore.setLoading(false)
  //     if (d.code == 0) {
  //       let getUserDeviceInfo = localstorage.get('getUserDeviceInfo')
  //       console.log('提交反馈成功', getUserDeviceInfo)
  //       this.setState({
  //         chooseImage: [],
  //         content: '',
  //         file: '',
  //         transactionId: ''
  //       })
  //       this.serviceStore.feedbackList(true)
  //       this.refs.success.close(true)
  //     } else {
  //       console.log('提交反馈失败')
  //       this.serviceStore.setToastContent(this.state.lang.submitFail)
  //       this.refs.toast.hideRule(true)
  //     }
  //     this.setState({
  //       submitRes: d,
  //       canSubmit: true
  //     })
  //   }
  // }

  async isUploadImg() {
    try {
      console.log('提交反馈')
      if (this.serviceStore.data.nav == 1) {
        let frObj = {
          // id 是 ftype
          id: this.state.selecttype,
          content: this.state.inpVal + `${this.state.inpVal ? ' - ' : ''}` + this.state.content,
          file: this.state.chooseImage.join(','),
          uid: parseInt(this.props.location.query.uid) || 0,
          gid: parseInt(this.props.location.query.gid) || 0,
          mid: parseInt(this.props.location.query.mid) || 0,
          transactionId: this.state.transactionId.toString() || '',
        }
        await this.serviceStore.postFeedbackOrReport(frObj)
      }
      console.log('提交举报')
      if (this.serviceStore.data.nav == 3) {
        let { uploadImgList } = this.state
        let frObj = {
          // id 是 ftype
          id: this.state.selectReportType,
          content: this.state.inpVal + `${this.state.inpVal ? ' | ' : ''}` + this.state.content,
          file: uploadImgList.join(','),
          uid: parseInt(this.props.location.query.uid) || 0,
          gid: parseInt(this.props.location.query.gid) || 0,
          mid: parseInt(this.props.location.query.mid) || 0,
          transactionId: this.state.transactionId.toString() || '',
        }
        await this.serviceStore.postFeedbackOrReport(frObj)
      }
    } catch (error) {
      this.serviceStore.setToastContent(this.state.lang.submitFail)
      this.refs.toast.hideRule(true)
    }
    await this.serviceStore.feedbackList(true)
    this.serviceStore.setLoading(false)
    // 展示成功提示框
    this.refs.success.close(true)
    this.setState({
      chooseImage: [],
      content: '',
      file: '',
      transactionId: '',
    })
  }

  reviewList() {
    let list = this.state.chooseImage
    if (list && list.length > 0) {
      return list.map((item, index) => {
        return (
          <div className="pic" key={index}>
            <img className="fpic" src={item} />
            <img
              className="del"
              src={`/img/app/service/del.png`}
              onClick={() => {
                this.delPic(index)
              }}
            />
          </div>
        )
      })
    }
  }

  delPic(index) {
    let list = this.state.chooseImage
    if (list.length >= index + 1 && list.length > 0) {
      list.splice(index, 1)
    } else {
      return
    }
    this.setState({
      chooseImage: list,
    })
  }
  setType(type) {
    this.setState({
      selecttype: type,
    })
  }

  // by Tang
  handleReportType(type) {
    this.setState({
      selectReportType: type,
    })
  }
  // by Tang end

  feedbackList(list) {
    if (list && list.length > 0) {
      return (
        <div className="feedbackList">
          {list.map((item, index) => {
            let filterContent = ''
            if (item.content.includes('|')) {
              filterContent = item.content.split('|')
            }
            return (
              <div
                className="item"
                key={index}
                onClick={() => {
                  this.displayFaqContent(item)
                }}
              >
                <div className={`redIcon ${item.isRead == 2 ? 'red' : ''}`}></div>
                <div className="borderBottom">
                  <div className="title">
                    {item.tab == 1 && <span className="frb">({this.state.lang.fbR})&nbsp;</span>}
                    {item.tab == 2 && <span className="frr">({this.state.lang.rpR})&nbsp;</span>}
                    <br />
                    {item.content || ''}
                  </div>
                  <div className="isReplied">
                    {item.isReplied == 1 ? this.state.lang.hasReply : ''}
                  </div>
                  <img className="arrow" src={`/img/app/service/arrow-right.png`} />
                </div>
              </div>
            )
          })}
        </div>
      )
    }
  }

  displayFaqContent = (item) => {
    this.serviceStore.setFeedbackContent(item)
    history.push(`/app/service/feedbackContent?id=${item.id}`)
  }

  setNav = (nav) => {
    if (nav == 1) {
      this.$logEvent('feeback_show_screen')
    }
    if (nav == 2) {
      this.$logEvent('report_show_screen')
    }
    if (nav == 3) {
      this.$logEvent('my_show_screen')
    }
    this.serviceStore.setNav(nav)
  }

  openSnap = async (status) => {
    this.refs.snap.hideRule(status)
  }

  openVideo = async (status) => {
    this.refs.video.hideRule(status)
  }

  render() {
    let language = this.state.language
    // language = 'ar'
    let data = this.serviceStore.data
    let {
      loading,
      faqContent,
      toastContent,
      uploadModal,
      nav,
      feedbackList,
      redCount,
      feedbackShowList,
      reportShowList,
      showlodingValue,
    } = data
    let selecttype = this.state.selecttype
    let selectReportType = this.state.selectReportType

    console.log('query', this.props.location.query)
    return (
      <div className={`service ${isRtl(language) && 'arlang'}`}>
        <Nav
          lang={this.state.lang}
          nav={nav}
          language={language}
          setNav={this.setNav.bind(this)}
          redCount={redCount}
          rpIsShow={this.serviceStore.data.rpIsShow}
        />

        {/* Feedback 模块 */}
        {nav == 1 && (
          <div className="feedbackPg">
            <div className={`ftype`}>
              {feedbackShowList &&
                feedbackShowList.length > 0 &&
                feedbackShowList.map((item, index) => {
                  return (
                    <div
                      className={`item ${selecttype == index + 1 && 'active'}`}
                      key={index}
                      onClick={() => {
                        this.setType(index + 1)
                      }}
                    >
                      {item.problem}
                    </div>
                  )
                })}
              {feedbackShowList.length == 0 && this.serviceStore.data.loadingContrl && (
                <img src="/img/other/loading.gif" />
              )}
            </div>
            {/* <div className="displayInfo"> */}
            {/* 选图结果：{JSON.stringify(this.state.chooseImage)}<br /><br /> */}
            {/* 用户信息：{JSON.stringify(this.state.userInfo)}<br /> */}
            {/* 上传结果：{JSON.stringify(this.state.uploadFile)}<br /> */}
            {/* 提交前：{JSON.stringify(this.state.submitPre)}<br /> */}
            {/* 提交结果：{JSON.stringify(this.state.submitRes)} */}
            {/* </div> */}
          </div>
        )}

        {/* 举报模块 */}
        {this.serviceStore.data.rpIsShow && nav == 3 && (
          <div className="report-part">
            <div className="report-types">
              {reportShowList &&
                reportShowList.length > 0 &&
                reportShowList.map((item, index) => {
                  return (
                    <div
                      className={`item ${selectReportType == index + feedbackShowList.length + 1 && 'active'} ${index == 1 || index == 3 || index == 4 ? 'item4' : ''}`}
                      key={index}
                      onClick={() => {
                        this.handleReportType(index + feedbackShowList.length + 1)
                      }}
                    >
                      {item.problem}
                    </div>
                  )
                })}
              {reportShowList.length == 0 && this.serviceStore.data.loadingContrl && (
                <img src="/img/other/loading.gif" />
              )}
            </div>
          </div>
        )}

        {nav != 2 && (
          <div
            onClick={() => {
              console.log(
                this.state.language,
                this.state.lang.leaveInfo,
                'sdsadasdasdasd--------------------',
              )
            }}
          >
            <span className="desc">{this.state.lang.leaveInfo}</span>
            <input
              className="inp"
              type="text"
              onChange={(e) => {
                this.setState({ inpVal: e.target.value })
              }}
            />
          </div>
        )}

        {(nav == 1 || nav == 3) && (
          <div className="upload-pic-video">
            {/* 问题标题 */}
            <div className="qtitle">
              <div className="title">{this.state.lang.des}</div>
              <div className="wordCount">
                {this.state.content.length}/{this.state.maxContentL}
              </div>
            </div>

            {/* 问题简述 */}
            <div className="qcontent">
              <textarea
                value={this.state.content}
                maxLength={this.state.maxContentL}
                ref={(node) => (this.sendContent = node)}
                placeholder={this.state.lang.placeholder}
                onChange={this.getAreaVal}
              ></textarea>
            </div>

            {/* 安卓订单展示 */}
            {nav == 1 && this.state.selecttype == 3 && brower.isAndroid() && (
              <div className="qtitle">
                <div className="title">
                  {this.state.lang.order}
                  {brower.isAndroid() && (
                    <img
                      className={`qu ${language == 'ar' && 'arlang'}`}
                      src="/img/app/service/qu.png"
                      onClick={() => {
                        this.openSnap(true)
                      }}
                    />
                  )}
                </div>
                <div className="wordCount"></div>
              </div>
            )}
            {nav == 1 && this.state.selecttype == 3 && brower.isAndroid() && (
              <div className="orderArea">
                <textarea
                  value={this.state.transactionId}
                  maxLength={255}
                  ref={(node) => (this.orderNo = node)}
                  placeholder={this.state.lang.noTransactionId}
                  onChange={this.getOrderVal}
                ></textarea>
              </div>
            )}

            {/* 【2  图片视频功能】 */}
            {!false && (
              <div className="qtitle">
                <div className="title">
                  {this.state.selecttype == 3 ? this.state.lang.ordersnap : this.state.lang.snap}
                  {this.state.selecttype == 3 && true && this.state.showVideo && (
                    // ios先不显示
                    <img
                      className={`qu ${isRtl(language) && 'arlang'}`}
                      src="/img/app/service/qu.png"
                      onClick={() => {
                        this.openVideo(true)
                      }}
                    />
                  )}
                  {this.state.selecttype == 3 && brower.isAndroid() && (
                    <img
                      className={`qu ${isRtl(language) && 'arlang'}`}
                      src="/img/app/service/qu.png"
                      onClick={() => {
                        this.openSnap(true)
                      }}
                    />
                  )}
                </div>
                <div className="wordCount">
                  {this.state.chooseImage.length}/{this.state.maxChooseL}
                </div>
              </div>
            )}

            {!false && (
              <div className="pics">
                {this.reviewList()}
                {this.state.chooseImage.length < this.state.maxChooseL && (
                  <div
                    className="pic"
                    onClick={() => {
                      this.androidUpload()
                    }}
                  >
                    {/* 苹果上传
                        <label className='select-img-input' htmlFor="upload">
                        </label> */}
                    <img className="fpic fan" src="/img/app/service/add.png" />
                  </div>
                )}
              </div>
            )}
            {/* 【2  图片视频功能】 */}

            {/* 苹果上传
              <input
                style={{ display: "none" }}
                id='upload'
                className='upload'
                onChange={(event) => this.onImgFileFn(event)}
                type='file'
                name='fileSelect'
                accept='*'
                multiple="mutiple"
              /> */}

            {/* 提交 */}
            <div
              className={`btn`}
              onClick={() => {
                this.uploadFile(nav)
              }}
            >
              {nav == 1 ? this.state.lang.submitF : this.state.lang.submitR}
            </div>
          </div>
        )}

        {/* My feedback 模块 */}
        {/* {nav == 2 && feedbackList.list.length == 0 && feedbackList.hasMore == true && <img className='loadingGif' src={`/img/other/loading.gif`} />} */}
        {nav == 2 && !showlodingValue && this.feedbackList(feedbackList.list)}
        {nav == 2 &&
          !showlodingValue &&
          feedbackList.list.length == 0 &&
          feedbackList.hasMore == false && <img className="empty3" src="/img/content_null_1.png" />}
        {nav == 2 &&
          !showlodingValue &&
          feedbackList.list.length == 0 &&
          feedbackList.hasMore == false && (
            <div className="nofeedback">{this.state.lang.nofeedback}</div>
          )}
        {nav == 2 && showlodingValue && (
          <div className="more">
            <img src="/img/other/loading.gif" />
          </div>
        )}

        {/* 客服 */}
        {this.state.language != 'tr' && (
          <div className="service-help" onClick={jumpToUser.bind(this, 977239)}>
            {this.state.lang.serviceHelp}
          </div>
        )}
        {this.state.language == 'tr' && (
          <div className="service-help" onClick={jumpToUser.bind(this, 113742)}>
            {this.state.lang.serviceHelp}
          </div>
        )}
        <Snap language={language} lang={this.state.lang} ref="snap" />
        <Video language={language} lang={this.state.lang} ref="video" />

        <Toast
          language={language}
          lang={this.state.lang}
          ref="toast"
          id="toast"
          toastContent={toastContent}
        />
        <Loading ref="loading" id="loading" status={loading} />
        <Modal
          ref="success"
          id="success"
          lang={this.state.lang}
          status={uploadModal}
          setNav={this.setNav.bind(this)}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/service/feedback.js